<template>
  <div>
    <b-modal
      id="addNote"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      :visible="showAddNote"
      @hidden="$emit('close-modal')"
    >
      <div>
        <div class="d-flex align-items-center justify-content-between p-3">
          <div class="b-modal-header">
            {{
              !noteTagData
                ? "Add Note"
                : noteTagData.type == "add"
                ? "Add Note"
                : "Edit Tags"
            }}
          </div>
          <div class="rotate-on-hover pointer">
            <img
              @click="$emit('close-modal')"
              v-b-tooltip.hover.top="'Close'"
              src="../../../assets/img/accessconnew/blueCross.svg"
              alt
            />
          </div>
        </div>
        <hr class="my-0" />

        <div class="px-4 pt-3 pb-4">
          <div class="topDiv">
            <div
              class="topDiv mt-1 mb-3"
              v-if="
                noteTagData &&
                (noteTagData.tags.length == 0 || noteTagData.type == 'edit')
              "
            >
              <FormTags
                :label="noteTagData.type == 'add' ? 'Tags' : 'Assigned Tags'"
                :mandatory="false"
                :vmodel="tags"
                @select-value="tags = $event"
                :placeholder="'Enter here'"
              />
            </div>
            <div>
              <div>
                <label class="fw-500 teams-label-font">Note</label>
              </div>
              <b-form-textarea
                class="newInt-previewInputField"
                placeholder="Enter"
                rows="3"
                max-rows="4"
                v-model.trim="$v.note.$model"
                :class="{ error: $v.note.$error || noteRequired }"
                v-on:keyup.enter="note ? submitAttachment() : ''"
              >
              </b-form-textarea>
              <div v-if="!$v.note.maxLength" class="error-txt-tc">
                Exceeded the max char length of 512
                <!-- Mandatory note is needed when you modify/delete existing tags -->
              </div>
              <div class="error-txt-tc mt-1" v-if="noteRequired">
                <img src="@/assets/img/newkanban/note-red-warning.svg" alt="" />
                Mandatory note is needed when you modify/delete existing tags
              </div>
            </div>

            <div
              class="mt-4"
              v-if="
                noteTagData &&
                noteTagData.type == 'add' &&
                noteTagData.tags.length != 0
              "
            >
              <template v-if="!editTags">
                <div class="d-flex align-items-center justify-content-between">
                  <h6 class="fs-13 fw-500 font-mont color-344054 mb-0">
                    Assigned Tags
                  </h6>
                  <img
                    @click="editTags = true"
                    src="../../../assets/img/botanalysis/kanbantagedit.svg"
                    alt=""
                  />
                </div>
                <div
                  class="
                    pc-notes-tags-overflow
                    d-flex
                    align-items-center
                    gap-10
                    mt-2
                    flex-wrap
                  "
                >
                  <div
                    class="
                      kanbancards-skilltags
                      fs-12
                      fw-400
                      font-lato
                      color-mainblue
                    "
                    style="border: none"
                    v-for="(tag, index) in noteTagData.tags"
                    :key="tag + index"
                  >
                    #{{ tag }}
                  </div>
                </div>
              </template>
              <div v-else class="topDiv mt-1">
                <div
                  @click="(editTags = false), assignTags()"
                  class="
                    fs-13
                    fw-500
                    font-mont
                    color-brightred
                    text-underline
                    cancel-edit-txt
                    pointer
                  "
                >
                  Cancel Edit
                </div>
                <div>
                  <label class="fw-500 teams-label-font">Assigned Tags</label>
                </div>
                <FormTags
                  :mandatory="false"
                  :vmodel="tags"
                  :noLabel="true"
                  @select-value="tags = $event"
                  :placeholder="'Enter here'"
                />
              </div>
            </div>
          </div>
        </div>

        <hr class="my-0" />

        <div
          :class="
            !showAttachment && showAttachmentInNote
              ? ' justify-content-between'
              : ' justify-content-end'
          "
          class="p-3 w-100 d-flex align-items-center"
        >
          <div
            class="pointer"
            @click="$emit('show-add-attachment')"
            v-if="!showAttachment && showAttachmentInNote"
          >
            <img
              class="mr-1"
              src="../../../assets/img/singleblueplus-icon.svg"
              alt=""
            />

            <span class="attach-font"> Add Attachment </span>
          </div>
          <div class="d-flex align-items-center bluebtn">
            <b-button
              class="acs-cancelBtn-modal mr-3"
              @click="$emit('close-modal')"
              >Cancel</b-button
            >
            <div class="position-relative">
              <b-button
                class="acs-addBtn-modal pl-4 pr-4"
                :class="
                  LoaderStatus ? 'send-loader-class defaultCursor' : 'pointer'
                "
                :disabled="!note"
                @click="submitAttachment()"
                >{{ LoaderStatus ? "" : "Save" }}</b-button
              >
              <div v-if="LoaderStatus" class="send-loader-pos">
                <Loader />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { maxLength, requiredIf } from "vuelidate/lib/validators";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import { addNoteAndAttachment } from "../../../utils/apiFunctions";
import toast from "../../mixin/toast";
import EventBus from "../../../utils/eventBus";
import FormTags from "../../../components/InputComponents/FormTags";
export default {
  name: "AddNote",
  props: {
    showAttachmentInNote: Boolean,
    viewCandidateModal: Boolean,
    showAttachment: Boolean,
    showAddNote: Boolean,
    candidateID: String,
    jobID: String,
    noteTagData: Object,
  },
  components: { Loader, FormTags },
  mixins: [toast],
  data() {
    return {
      note: null,
      LoaderStatus: false,
      editTags: false,
      tags: [],
    };
  },
  validations: {
    note: {
      maxLength: maxLength(512),
      required: requiredIf(function () {
        return (
          this.noteTagData &&
          ((this.noteTagData?.type == "add" &&
            this.noteTagData?.tags.length == 0 &&
            this.tags.length != 0) ||
            !this.tagsEqual(this.tags, this.noteTagData.tags))
        );
      }),
    },
  },
  created() {
    if (this.noteTagData && this.noteTagData.tags.length != 0)
      this.assignTags();
    this.clearForm();
  },
  computed: {
    noteRequired() {
      return (
        this.noteTagData &&
        !this.note &&
        !this.tagsEqual(this.tags, this.noteTagData.tags)
      );
    },
  },
  methods: {
    tagsEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;
      return arr1.every((value, index) => value === arr2[index]);
    },
    assignTags() {
      this.tags = JSON.parse(JSON.stringify(this.noteTagData.tags));
    },
    clearForm() {
      this.note = null;
      this.$v.$reset();
      this.$forceUpdate();
    },
    async submitAttachment() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.LoaderStatus = true;
        try {
          let form = new FormData();
          form.append("candidateID", this.candidateID);
          if (!this.showAttachment) {
            form.append("jobID", this.jobID);
          }
          form.append("note", this.note);
          if (this.noteTagData) {
            if (!this.tags) this.tags = [];
            form.append("tags", JSON.stringify(this.tags));
          }
          const res = await addNoteAndAttachment(form);
          if (res.status == 200) {
            if (!this.viewCandidateModal) EventBus.$emit("notes-added");
            else if (this.$route.name == "Kanban") this.$emit("refresh-round");
            else if (this.$route.name == "TalentPool")
              this.$emit("update-talentpool");
            this.dynamicToast(
              "success",
              "Successfully added",
              "Note added successfully"
            );
            this.clearForm();
            this.$emit("close-modal");
          } else {
            this.errorModal("Something went wrong!");
          }
          this.LoaderStatus = false;
        } catch (err) {
          this.errorModal("Something went wrong!");
          this.LoaderStatus = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.send-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 80px;
}
.send-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -4px;
}

.newInt-previewInputField.form-control {
  font-weight: 500;
  color: #333;
}

.cancel-edit-txt {
  text-align: end;
  margin-bottom: -23px;
}
</style>
